// full library entry point.

"use strict";
module.exports = require("./src/index");



//////////////////
// WEBPACK FOOTER
// ./node_modules/protobufjs/index.js
// module id = 551
// module chunks = 0